import { formatParisDate, type ChargeFailureListItem } from '@flux/shared';
import { formatEuros } from './money.js';

/**
 * Valeurs dérivées d'un paiement échoué, partagées par la liste et le
 * panneau (`06` §2.1, §8.1). `null` = afficher « — ».
 */

/** Montant relu chez Recharge (décimal en chaîne), formaté à la française : `29,90 €`. */
export function chargeFailureAmount(item: Pick<ChargeFailureListItem, 'amount'>): string | null {
  return formatEuros(item.amount);
}

/** `N/M` ; `null` quand Recharge n'a pas donné le nombre de tentatives (N = 0). */
export function chargeFailureAttempt(
  item: Pick<ChargeFailureListItem, 'attempt' | 'maxAttempts'>,
): string | null {
  return item.attempt > 0 ? `${String(item.attempt)}/${String(item.maxAttempts)}` : null;
}

/** Date de la prochaine relance ; aucune après un échec définitif. */
export function chargeFailureNextRetry(
  item: Pick<ChargeFailureListItem, 'retryDate' | 'status'>,
): string | null {
  if (item.retryDate === null || item.status === 'final') {
    return null;
  }
  const date = new Date(item.retryDate);
  return Number.isNaN(date.getTime()) ? item.retryDate : formatParisDate(date);
}

/** Message d'erreur lisible : message nettoyé, sinon le code Recharge. */
export function chargeFailureError(
  item: Pick<ChargeFailureListItem, 'errorMessage' | 'errorType'>,
): string {
  return item.errorMessage ?? item.errorType ?? 'Non renseignée';
}
